import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CaptionOptions } from './types';

@Component({
  selector: 'table-caption',
  templateUrl: './caption.component.html',
  styleUrls: ['./caption.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaptionComponent {
  @Input() options?: CaptionOptions;
  @Output() onButtonClicked: EventEmitter<void> = new EventEmitter();

  onClickButton() {
    this.onButtonClicked.emit();
  }
}
